import { render } from "./Button.vue?vue&type=template&id=9f0596a2&bindings={\"label\":\"props\",\"icon\":\"props\",\"iconPos\":\"props\",\"badge\":\"props\",\"badgeClass\":\"props\",\"buttonClass\":\"options\",\"iconClass\":\"options\",\"badgeStyleClass\":\"options\"}"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
script.render = render

export default script